export default __webpack_public_path__ + "static/media/header.deb18857.png";